<div class="dashboard-container " [class.dashboard-loading]="!isAuthorized" [attr.aria-busy]="!isAuthorized">
    <div class="tabs-container  position-relative">
        <div class="d-flex align-items-center w-auto gap-2">
            @if (isSideNavOpen) {
            <mat-icon class="d-flex align-items-center justify-content-center"
                (click)="requestCloseSideNav()">arrow_back</mat-icon>
            }
            @else {
            <mat-icon class="d-flex align-items-center justify-content-center" (click)="toggleSideNav()">apps</mat-icon>
            }
            <div class="tab-group" (click)="requestCloseSideNav()">
                <mat-tab-group [selectedIndex]="selectedVisualTabIndex" (selectedTabChange)="onTabChange($event)">
                    <mat-tab label="{{'ESTIMATE' | translate}}">
                    </mat-tab>
                    @if(isReviewTabVisible) {
                    <mat-tab>
                        <ng-template mat-tab-label>{{'REVIEW' | translate}}{{isReReviewNeeded ? '*' : ''}}</ng-template>
                    </mat-tab>
                    }
                    <mat-tab label="{{'REPORTS' | translate}}">
                    </mat-tab>
                </mat-tab-group>
                <img [src]="syncStatusGifPath" [title]="syncStatusTooltip" alt="Sync Status"
                    class="sync-status-icon cursor-pointer" (click)="openSyncMenu($event)"
                    [matMenuTriggerFor]="syncMenu" #syncMenuTrigger="matMenuTrigger">
                <mat-menu #syncMenu="matMenu">
                    <button mat-menu-item (click)="getSyncData()" [disabled]="!estimateId">
                        <span>{{'SYNCHRONIZE' | translate}}</span>
                    </button>
                </mat-menu>
                @if(newMessages || allMessagesDeleted){
                <mat-icon class="d-flex align-items-center"
                    [matTooltip]="newMessages ? ('NEW_MESSAGES_AVAILABLE' | translate) : ('NO_MESSAGE' | translate)"
                    [ngClass]="{'deleted-mail-icon': allMessagesDeleted}" (click)="openMailDialog()">mail</mat-icon>
                } @else {
                <mat-icon class="d-flex align-items-center" matTooltip="{{'NO_NEW_MESSAGES' | translate}}"
                    (click)="openMailDialog()">mail_outline</mat-icon>
                }
                @switch (getCollaborationState()) {
                @case (CollaborationState.Open) {
                <span (click)="openCollaborationDialog()" class="collaboration-hub">
                    <img [src]="'assets/images/CollaborationOpen.png'" alt="open collaboration">
                </span>
                }
                @case (CollaborationState.Locked) {
                <span (click)="openCollaborationDialog()" class="collaboration-hub">
                    <img [src]="'assets/images/CollaborationLocked.png'" alt="locked collaboration">
                </span>
                }
                @case (CollaborationState.Edit) {
                <div class="collab-edit-wrapper">
                    <span (click)="accessRequests.length > 0 ? openAccessRequests() : openCollaborationDialog()"
                        class="collaboration-hub">
                        <img [src]="'assets/images/CollaborationEdit.png'" alt="edit collaboration">
                    </span>
                    @if (accessRequests.length > 0) {
                    <span class="access-requests-btn-wrapper">
                        <button mat-raised-button color="primary" (click)="openAccessRequests()">
                            {{ 'ACCESS_REQUESTS' | translate }}
                            <mat-icon iconPositionEnd>arrow_downward</mat-icon>
                        </button>
                    </span>
                    }
                </div>
                }
                @case (CollaborationState.NonCollaborative) {
                <!-- No icon displayed for non-collaborative state -->
                }
                }

                <button mat-raised-button color="primary" hidden>
                    SAVE
                </button>
            </div>
        </div>
        <div class="estimate-id-group">
            @if (isSapSubmitted) {
            <span (click)="unlockSubmittedEstimate()">
                <img src="assets/images/Lock.gif" alt="Lock" class="lock-icon">
            </span>
            }
            @if(estimateId !== emptyString){
            <p class="cursor-pointer m-0" (click)="toggleEstimateDisplay()" *ngIf="showEstimateId">{{estimateId}}</p>
            <p class="cursor-pointer m-0" (click)="toggleEstimateDisplay()" *ngIf="!showEstimateId">{{estimateName}}</p>
            <mat-icon (click)="copyEstimateId()" class="cursor-pointer copy-icon" [class.copied]="isCopied"
                [title]="isCopied ? 'Copied!' : ('CLICK_TO_COPY_ESTIMATEID_OR_ESTIMATENAME' | translate)">{{ isCopied ?
                'check_circle' : 'file_copy'
                }}</mat-icon>
            }
        </div>
    </div>
    <div class="main-content">
        @if (showProjectViewCollapsedTag) {
        <div class="side-bar">
            <div class="dash-labels">
                <span class="vertical-text-span" (click)="openLibrary(SOLUTION_LIBRARY_ITEMS.ProjectView)">{{'PROJECT' |
                    translate}}</span>
            </div>
        </div>
        }
        @if (showReportViewCollapsedTag) {
        <div class="side-bar">
            <div class="dash-labels">
                <span class="vertical-text-span"
                    (click)="openLibrary(SOLUTION_LIBRARY_ITEMS.ReportView)">{{'REPORT_VIEW' | translate}}</span>
            </div>
        </div>
        }
        <div class="split-container">
            <as-split class="as-split" direction="horizontal" gutterSize="7" (dragEnd)="dragEndSplittedArea($event)">
                <as-split-area [size]="safeLeftSize" [visible]="showProjectViewArea">
                    <as-split class="as-split" direction="vertical" gutterSize="7">
                        <!-- <as-split-area [size]="previewPanelHeight" [visible]="isPreviewViewVisible && !navBarService.isPreviewViewClosed">
                            <app-preview (unpinPreviewLibrary)="unpinLibrary($event)" (closePreviewLibrary)="closeLibrary($event)"></app-preview>
                        </as-split-area> -->
                        <as-split-area [size]="projectViewPanelHeight"
                            [visible]="isProjectViewVisible && !navBarService.isProjectViewClosed">
                            <app-project-view-tree (unpinPreviewLibrary)="unpinLibrary($event)"
                                (closeProjectViewLibrary)="closeLibrary($event)" [projectViewLayout]="projectViewLayout"
                                [isEstimateTab]="isEstimateTab"></app-project-view-tree>
                        </as-split-area>
                    </as-split>
                </as-split-area>
                <as-split-area [size]="safeCenterSize">
                    <mat-card class="dashboard-card">
                        <mat-card-content class="p-0">
                            @switch (selectedTabIndex) {
                            @case (projectTabs.Estimate) {
                            <app-estimates></app-estimates>
                            }
                            @case (projectTabs.Review) {
                            @if (isReviewTabVisible) {
                            <app-review-detail [readOnlyView]="readOnlyMode"></app-review-detail>
                            }
                            }
                            @case (projectTabs.Reports) {
                            <app-reports-wrapper [showReportView]="showReportViewArea"
                                [isReportContentVisible]="isReportContentVisible"
                                [isReviewTabVisible]="isReviewTabVisible" (unpinReportView)="unpinLibrary($event)"
                                (closeReportView)="closeLibrary($event)">
                            </app-reports-wrapper>
                            }
                            }
                        </mat-card-content>
                    </mat-card>
                </as-split-area>
                <as-split-area [size]="safeRightSize" [visible]="showRightLibraries">
                    <as-split class="as-split" direction="vertical" gutterSize="7">
                        <as-split-area [size]="50"
                            [visible]="isCostSummaryVisible && !navBarService.isCostSummaryClosed">
                            <app-cost-summary-view (unpinCostSummaryLibrary)="unpinLibrary($event)"
                                (closeCostSummaryLibrary)="closeLibrary($event)"></app-cost-summary-view>
                        </as-split-area>
                        <as-split-area [size]="50" [visible]="isLibraryVisible && !navBarService.isLibraryClosed">
                            <app-library-view (unpinLibraryView)="unpinLibrary($event)"
                                (closeLibraryView)="closeLibrary($event)"></app-library-view>
                        </as-split-area>
                    </as-split>
                </as-split-area>
            </as-split>
        </div>
        @if (showRightCollapsedTags) {
        <div class="side-bar">
            <div class="dash-labels">
                @if (!isCostSummaryVisible && !navBarService.isCostSummaryClosed) {
                <span class="vertical-text-span"
                    (click)="openLibrary(SOLUTION_LIBRARY_ITEMS.CostSummaryView)">{{'COST_SUMMARY' | translate}}</span>
                }
                @if (!isLibraryVisible && !navBarService.isLibraryClosed) {
                <span class="vertical-text-span"
                    (click)="openLibrary(SOLUTION_LIBRARY_ITEMS.LibraryView)">{{'LIBRARY_VIEW' | translate}}</span>
                }
            </div>
        </div>
        }
        @if (isSideNavOpen) {
        <app-side-nav-bar [selectedTabIndex]="selectedTabIndex" ; (closeSidenav)="closeSideNav()"
            (saveCurrentWorkspaceEvent)="saveCurrentWorkspace()" (resetCurrentWorkspaceEvent)="resetCurrentWorkspace()"
            (resetFactoryWorkspaceEvent)="resetFactoryWorkspace()" (toggleLibraryEvent)="toggleLibrary($event)"
            (navigateToEstimateTabEvent)="navigateToEstimateTab()"
            (navigateToEstimateTabWithoutCloseEvent)="navigateToEstimateTabWithoutClosingSideNav()"
            (setDefaultEstimateId)="setDefaultEstimateId()">
        </app-side-nav-bar>
        }

    </div>
    @if (!isSideNavOpen) {
        <app-status-bar></app-status-bar>
    }
</div>